import React, { useCallback, useEffect, useMemo } from 'react';
import { DefaultQueryParams, isMobile, MainWr, parseQuery, platformMessageStore } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { Factory } from './core';
import { WebGame } from './conatiners/webGame';
import { BrowserRouter } from 'react-router-dom';
import { MobileGame } from './conatiners/mobileGame';
import { gameLiveConnection } from './services';
import { TableLobbyWr } from './conatiners/lobby';
import { RoutePaths } from './enums/routes';
import { popupStore } from '@pascal/pascal-core/shared/core/store';
import BetShopGame from './conatiners/betShopGame';
import { BET_SHOP_GAME_ID } from './enums/constants';
import useDocumentVisibility from './hooks/useDocumentVisibility';
import { visibilityChangeHandler } from './helpers/visibilityChangeHandler';
import './index.css';

let timeoutId;

const App = observer(() => {
  const { [DefaultQueryParams.GameId]: gameId } = parseQuery(window.location.search);
  const isBetShop = +gameId === BET_SHOP_GAME_ID;
  const { isRepliedGame } = platformMessageStore;

  useDocumentVisibility(visibilityChangeHandler, 2000);

  const components = useMemo(
    () => [
      {
        path: isBetShop || isRepliedGame ? `${RoutePaths.lobby}lobby` : RoutePaths.lobby,
        element: <TableLobbyWr />,
        defaultRedirectComponent: !isBetShop && !isRepliedGame,
      },
      {
        path: RoutePaths.game,
        element: isMobile() ? <MobileGame /> : <WebGame />,
      },
      {
        path: RoutePaths.betShop,
        element: <BetShopGame />,
        defaultRedirectComponent: isBetShop,
      },
      {
        path: RoutePaths.replay,
        element: isMobile() ? <MobileGame isReplay /> : <WebGame isReplay />,
        defaultRedirectComponent: isRepliedGame,
      },
    ],
    [isBetShop, isRepliedGame]
  );

  const reconnectInternet = useCallback(() => {
    if (!popupStore.connectionError) {
      clearTimeout(timeoutId);
      popupStore.close();
      popupStore.toggleReconnect(false);
    }
  }, [popupStore.connectionError]);

  const lostInternetConnection = useCallback(() => {
    popupStore.toggleReconnect(true);
    timeoutId = setTimeout(() => {
      popupStore.onConnectionError(true);
      gameLiveConnection.stop();
    }, 5000);
  }, []);

  useEffect(() => {
    window.addEventListener('offline', lostInternetConnection);
    window.addEventListener('online', reconnectInternet);
    return () => {
      window.removeEventListener('offline', lostInternetConnection);
      window.removeEventListener('online', reconnectInternet);
    };
  }, [lostInternetConnection]);

  return (
    <>
      <BrowserRouter>
        <MainWr>
          <Factory
            components={components}
            // connectionInitCallback={connectionInitCallback}
          />
        </MainWr>
      </BrowserRouter>
    </>
  );
});

export default App;
